import {
  CrashComponent,
  ErrorComponent,
  ErrorCustomComponent,
  InfoToolComponent,
  SimulateDelayToolComponent,
} from "./DebugTool";
import { TextReplaceToolComponent } from "./TextReplaceToolComponent";

export default function ToolsComponentWrapper() {
  return (
    <>
      <ErrorComponent />
      <CrashComponent />
      <InfoToolComponent />
      <SimulateDelayToolComponent />
      <ErrorCustomComponent />
      <TextReplaceToolComponent />
    </>
  );
}
